const Rigging = props => (
  <svg {...props} width="16px" height="16px" viewBox="0 0 51 51">
    <g id="Artboard-3-Copy" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-140.000000, -110.000000)">
      <g id="Rigging" transform="translate(140.000000, 110.000000)" fill="#313F4C" fillRule="nonzero">
        <path d="M25.5,50.5 C11.6928813,50.5 0.5,39.3071187 0.5,25.5 C0.5,11.6928813 11.6928813,0.5 25.5,0.5 C39.3071187,0.5 50.5,11.6928813 50.5,25.5 C50.5,39.3071187 39.3071187,50.5 25.5,50.5 Z M25.5,45.5 C36.545695,45.5 45.5,36.545695 45.5,25.5 C45.5,14.454305 36.545695,5.5 25.5,5.5 C14.454305,5.5 5.5,14.454305 5.5,25.5 C5.5,36.545695 14.454305,45.5 25.5,45.5 Z" id="Oval"></path>
        <path d="M28,23 L50,23 L50,28 L28,28 L28,48.7400017 L23,48.7400017 L23,28 L0.900001526,28 L0.900001526,23 L23,23 L23,1 L28,1 L28,23 Z" id="Combined-Shape"></path>
      </g>
    </g>
  </svg>
);

export default Rigging;
